<div id="safety-productivity-indicators"></div>